import React, {
  FC, useEffect, useState,
} from 'react';
import Header from '../../../../Common/Header';
import { getCabId, getWindowWidth } from '../../../../../../lib/utils/utils';
import SquadRegularText from '../../../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../../../components/Text/PingFangRegularText';
import BackgroundImage from '../../../../../../components/BackgroundImage';
import Title from './Title';
import Tabs from './Tabs';
import ColumnCenter from '../../../../../../components/Layout/ColumnCenter';
import SquadSemiBoldText from '../../../../../../components/Text/SquadSemiBoldText';
import PingFangMediumText from '../../../../../../components/Text/PingFangMediumText';
import SearchInput from './SearchInput';
import SearchName from './SearchName';
import SearchPhone from './SearchPhone';
import { updateFoodifoxData } from '../../../../../../lib/axios/FoodifoxDataAPI';
import { addSystemLog } from '../../../../../../lib/SystemLogUtils';
import { Box } from '../../../../../../lib/types';
import ReopenBoxSuccess from '../Code/ReopenBoxSuccess';

const SearchUser: FC<Props> = ({
  cabId32Str,
  selectedPlatform,
  isEnglish,
  setIsEnglish,
  setShowLoading,
  driverId,
  onClose,
}) => {
  const [reopenBox, { loading: rentLoading }] = updateFoodifoxData<Box[]>('/foxH5Driver/reopenOrderBoxByUserId');
  const [tabIndex, setTabIndex] = useState<number>(0);
  const [searchKey, setSearchKey] = useState<string>();
  // 收件人信息
  const [parcelUserInfo, setParcelUserInfo] = useState<{ searchType: string; userId: number; userName: string; phoneNumber: string }>();
  const [orderInfo, setOrderInfo] = useState<{ openBoxes: Box[] }>();

  useEffect(() => {
    setShowLoading(rentLoading);
    return () => {
      setShowLoading(false);
    };
  }, [rentLoading]);

  /**
   * 选择确认用户后
   * @param searchType
   * @param userId
   * @param userName
   * @param phoneNumber
   */
  const selectedUserCallback = (searchType: string, userId: number, userName: string, phoneNumber: string) => {
    setParcelUserInfo({ userId, userName, searchType, phoneNumber });
    if (selectedPlatform == null) {
      return;
    }
    if (driverId == null) {
      return;
    }
    reopenBox({
      param: {
        cabId: cabId32Str,
        platform: selectedPlatform,
        userId,
      },
      onCompleted(openBoxes) {
        setOrderInfo({ openBoxes });
        addSystemLog(getCabId(cabId32Str), '', selectedPlatform + '', '骑手ID：' + driverId + '，重新打开柜门：' + JSON.stringify(openBoxes.map((box) => box.boxNumber)) + '，searchType：' + searchType + '，userId：' + userId + '，userName：' + userName + '，phoneNumber：' + phoneNumber);
      },
    });
  };

  return (
    <>
      {
        (!orderInfo) && (
          <BackgroundImage>
            {/* 头部 */}
            <Header
              isEnglish={isEnglish}
              setIsEnglish={setIsEnglish}
              style={{ marginTop: 20 }}
              supportIsOnlyCall={true}
              cabId32Str={cabId32Str}
            />

            {/* 标题 */}
            <Title onClose={onClose} />
            {/* Tabs */}
            <Tabs
              isEnglish={isEnglish}
              tabIndex={tabIndex}
              setTabIndex={setTabIndex}
            />

            <ColumnCenter style={{ marginTop: 15 }}>
              {
                isEnglish ? (
                  <SquadSemiBoldText fontSize={15} lineHeight={19} opacity={0.5}>
                    Please note:
                  </SquadSemiBoldText>
                ) : (
                  <PingFangMediumText fontSize={15} lineHeight={19} opacity={0.5}>
                    请注意：
                  </PingFangMediumText>
                )
              }
              {
                isEnglish ? (
                  <SquadRegularText fontSize={15} lineHeight={19} opacity={0.5}>
                    You can only deliver food to registered users.
                  </SquadRegularText>
                ) : (
                  <PingFangRegularText fontSize={15} lineHeight={22} opacity={0.5}>
                    你只能向已注册用户配送食物。
                  </PingFangRegularText>
                )
              }

              {/* 搜索框 */}
              <SearchInput onChange={setSearchKey} />

              {
                tabIndex === 0 && (
                  <>
                    <SearchName
                      isEnglish={isEnglish}
                      cabId={getCabId(cabId32Str)}
                      searchText={searchKey}
                      selectUserCallback={(userId: number, userName: string, phoneNumber) => {
                        selectedUserCallback('name', userId, userName, phoneNumber);
                      }}
                    />

                    <ColumnCenter style={{ marginTop: 36, marginBottom: 50 }}>
                      {
                        isEnglish ? (
                          <SquadSemiBoldText fontSize={15} lineHeight={19}>
                            Need help finding the name?
                          </SquadSemiBoldText>
                        ) : (
                          <PingFangMediumText fontSize={15} lineHeight={19}>
                            需要帮忙找到这个名字吗？
                          </PingFangMediumText>
                        )
                      }
                      {
                        isEnglish ? (
                          <SquadRegularText fontSize={15} lineHeight={19} maxWidth={getWindowWidth() - 50}>
                            The recipient’s name can either be found on on the <SquadSemiBoldText color={'#00B595'} isSpan={true}>delivery docket attached to an order</SquadSemiBoldText> or you can locate it <SquadSemiBoldText color={'#00B595'} isSpan={true}>on your delivery application.</SquadSemiBoldText>
                          </SquadRegularText>
                        ) : (
                          <PingFangRegularText fontSize={15} lineHeight={22} maxWidth={getWindowWidth() - 50}>
                            收件人的姓名可以在 <SquadSemiBoldText color={'#00B595'} isSpan={true}>附在订单上的交货单</SquadSemiBoldText> 上找到，或者你也可以在 <SquadSemiBoldText color={'#00B595'} isSpan={true}>你的送货应用程序上找到它。</SquadSemiBoldText>
                          </PingFangRegularText>
                        )
                      }
                    </ColumnCenter>
                  </>
                )
              }
              {
                tabIndex === 1 && (
                  <>
                    <SearchPhone
                      isEnglish={isEnglish}
                      cabId={getCabId(cabId32Str)}
                      searchText={searchKey}
                      selectUserCallback={(userId: number, userName: string, phoneNumber) => {
                        selectedUserCallback('phone', userId, userName, phoneNumber);
                      }}
                    />

                    <ColumnCenter style={{ marginTop: 36, marginBottom: 50 }}>
                      {
                        isEnglish ? (
                          <SquadSemiBoldText fontSize={15} lineHeight={19}>
                            Need help finding the phone number?
                          </SquadSemiBoldText>
                        ) : (
                          <PingFangMediumText fontSize={15} lineHeight={19}>
                            需要帮忙找到电话号码吗？
                          </PingFangMediumText>
                        )
                      }
                      {
                        isEnglish ? (
                          <SquadRegularText fontSize={15} lineHeight={19} maxWidth={getWindowWidth() - 50}>
                            The recipient’s phone number can either be found on on the <SquadSemiBoldText color={'#00B595'} isSpan={true}>delivery docket attached to an order</SquadSemiBoldText> or you can locate it <SquadSemiBoldText color={'#00B595'} isSpan={true}>on your delivery application.</SquadSemiBoldText>
                          </SquadRegularText>
                        ) : (
                          <PingFangRegularText fontSize={15} lineHeight={22} maxWidth={getWindowWidth() - 50}>
                            收件人的电话号码可以在 <SquadSemiBoldText color={'#00B595'} isSpan={true}>附在订单上的交货单</SquadSemiBoldText> 上找到，或者你也可以在 <SquadSemiBoldText color={'#00B595'} isSpan={true}>你的送货应用程序上找到它。</SquadSemiBoldText>
                          </PingFangRegularText>
                        )
                      }
                    </ColumnCenter>
                  </>
                )
              }
            </ColumnCenter>
          </BackgroundImage>
        )
      }
      {
        orderInfo && parcelUserInfo && (
          <ReopenBoxSuccess
            cabId32Str={cabId32Str}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setShowLoading={setShowLoading}
            driverId={driverId}
            onClose={onClose}
            openedBoxes={orderInfo.openBoxes}
          />
        )
      }
    </>
  );
};

export interface Props {
  cabId32Str: string;
  selectedPlatform: number;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setShowLoading: (isShow: boolean) => void;
  driverId: number;
  onClose: () => void;
}

export default SearchUser;
